import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createDecorator } from '../../instantiation/common/instantiation.js';
export var Progress = /*#__PURE__*/function () {
  function Progress(callback) {
    _classCallCheck(this, Progress);

    this.callback = callback;
  }

  _createClass(Progress, [{
    key: "report",
    value: function report(item) {
      this._value = item;
      this.callback(this._value);
    }
  }]);

  return Progress;
}();
Progress.None = Object.freeze({
  report: function report() {}
});
export var IEditorProgressService = createDecorator('editorProgressService');